/*

E.g. for the 'admin' pathname the following routes will be considered as a match:
- /admin
- /admin/
- /admin/users

And the following routes will not be considered as a match:
- /admin2
- /adminuser

 */
export const matchRoute = (pathname: string, route: string) => {
  const regex = new RegExp(`^${route.replace(/\//g, "\\/")}(\\/.*)?$`);
  return regex.test(pathname);
};
